"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _vuex = require("vuex");
var _attendanceRecords = require("@/services/attendance-records.service");
var _chart = _interopRequireDefault(require("chart.js"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'TimesheetsDashboard',
  components: {
    Page: _Page.default
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsAttendanceRecords',
    farm: 'GET_FARM'
  })),
  data: function data() {
    return {
      filters: {
        period: 'all' // all | week | month | year
      },
      topNegative: [],
      topPositive: [],
      monthSeries: [],
      isLoading: {
        negative: false,
        positive: false,
        chart: false
      },
      chart: null
    };
  },
  methods: {
    onFilterChange: function onFilterChange() {
      this.fetchAll();
    },
    fetchAll: function () {
      var _fetchAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.all([this.fetchTopNegative(), this.fetchTopPositive(), this.fetchMonthlyChart()]);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fetchAll() {
        return _fetchAll.apply(this, arguments);
      }
      return fetchAll;
    }(),
    fetchTopNegative: function () {
      var _fetchTopNegative = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$farm, _response$data, _yield$attendanceReco, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.isLoading.negative = true;
              _context2.p = 1;
              _context2.n = 2;
              return _attendanceRecords.attendanceRecordsService.fetchTimesheetsReports({
                page: 1,
                limit: 10,
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id,
                period: this.filters.period,
                orderBy: 'balance',
                orderDirection: 'asc'
              });
            case 2:
              _yield$attendanceReco = _context2.v;
              response = _yield$attendanceReco.data;
              this.topNegative = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.$buefy.toast.open({
                message: _t.message,
                type: 'is-danger'
              });
            case 4:
              _context2.p = 4;
              this.isLoading.negative = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function fetchTopNegative() {
        return _fetchTopNegative.apply(this, arguments);
      }
      return fetchTopNegative;
    }(),
    fetchTopPositive: function () {
      var _fetchTopPositive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$farm2, _response$data2, _yield$attendanceReco2, response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.isLoading.positive = true;
              _context3.p = 1;
              _context3.n = 2;
              return _attendanceRecords.attendanceRecordsService.fetchTimesheetsReports({
                page: 1,
                limit: 10,
                farmId: (_this$farm2 = this.farm) === null || _this$farm2 === void 0 ? void 0 : _this$farm2.id,
                period: this.filters.period,
                orderBy: 'balance',
                orderDirection: 'desc' // maiores saldos (mais positivos) primeiro
              });
            case 2:
              _yield$attendanceReco2 = _context3.v;
              response = _yield$attendanceReco2.data;
              this.topPositive = (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : [];
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.$buefy.toast.open({
                message: _t2.message,
                type: 'is-danger'
              });
            case 4:
              _context3.p = 4;
              this.isLoading.positive = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchTopPositive() {
        return _fetchTopPositive.apply(this, arguments);
      }
      return fetchTopPositive;
    }(),
    fetchMonthlyChart: function () {
      var _fetchMonthlyChart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this = this;
        var _this$farm3, _response$data3, _yield$attendanceReco3, response, rows, grouped, _iterator, _step, r, key, labels, balances, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.isLoading.chart = true;
              _context4.p = 1;
              _context4.n = 2;
              return _attendanceRecords.attendanceRecordsService.fetchTimesheetsReports({
                page: 1,
                limit: 200,
                farmId: (_this$farm3 = this.farm) === null || _this$farm3 === void 0 ? void 0 : _this$farm3.id,
                period: 'week',
                orderBy: 'periodStart',
                orderDirection: 'asc'
              });
            case 2:
              _yield$attendanceReco3 = _context4.v;
              response = _yield$attendanceReco3.data;
              rows = (_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : [];
              grouped = new Map();
              _iterator = _createForOfIteratorHelper(rows);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  r = _step.value;
                  key = (0, _moment.default)(r.periodStart).format('DD/MM');
                  grouped.set(key, (grouped.get(key) || 0) + (r.balance || 0));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              labels = Array.from(grouped.keys());
              balances = Array.from(grouped.values()).map(function (v) {
                return _this.secondsToHours(v);
              });
              this.monthSeries = {
                labels: labels,
                balances: balances
              };
              this.renderChart();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              this.$buefy.toast.open({
                message: _t3.message,
                type: 'is-danger'
              });
            case 4:
              _context4.p = 4;
              this.isLoading.chart = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function fetchMonthlyChart() {
        return _fetchMonthlyChart.apply(this, arguments);
      }
      return fetchMonthlyChart;
    }(),
    renderChart: function renderChart() {
      var ctx = this.$refs.monthChart;
      if (!ctx) return;
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new _chart.default(ctx, {
        type: 'bar',
        data: {
          labels: this.monthSeries.labels,
          datasets: [{
            label: 'Saldo horas / semana',
            data: this.monthSeries.balances,
            barPercentage: 0.4,
            categoryPercentage: 0.6
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              ticks: {
                callback: function callback(v) {
                  return "".concat(v, " h");
                }
              }
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: function label(ctx) {
                  return "Saldo: ".concat(ctx.parsed.y, " h");
                }
              }
            }
          }
        }
      });
    },
    // ---- Helpers ----
    formatSeconds: function formatSeconds(seconds) {
      var sign = seconds < 0 ? '-' : '';
      var s = Math.abs(seconds || 0);
      var totalMinutes = Math.floor(s / 60);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = String(totalMinutes % 60).padStart(2, '0');
      return "".concat(sign).concat(hours, ":").concat(minutes);
    },
    secondsToHours: function secondsToHours(seconds) {
      var h = (seconds || 0) / 3600;
      return Math.round(h * 100) / 100;
    },
    formatYearMonth: function formatYearMonth(d) {
      var date = new Date(d);
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      return "".concat(y, "-").concat(m);
    }
  },
  mounted: function mounted() {
    this.fetchAll();
  }
};